<template>
  <div class="filter-selects">
    <vue-select
      v-if="activeSelectEquipes"
      :options="equipes"
      label="no_equipe"
      placeholder="Equipes"
      @input="handleEquipe"
    >
      <template slot="option" slot-scope="option">
        {{ option.no_equipe }}
        {{ option.nu_ine != 'sem-equipe' ? '- ' + option.nu_ine : '' }}
      </template>
      <div slot="no-options">Não há opções correspondentes</div>
    </vue-select>
    <vue-select
      v-if="activeSelectProfissionais"
      :options="profissionais"
      label="no_profissional"
      placeholder="Profissionais"
      @input="handleProfissional"
      :loading="loadingSelectProfissionais"
      :disabled="disabledSelectProfissionais"
      v-model="profissional"
    >
      <div slot="no-options">Não há opções correspondentes</div>
    </vue-select>
    <vue-select
      v-if="activeSelectMicroArea"
      :options="microareas"
      label="micro_area"
      placeholder="Microárea"
      @input="handleMicroArea"
      :loading="loadingSelectMicroAreas"
      :disabled="disabledSelectMicroAreas"
      v-model="microarea"
    >
      <template slot="option" slot-scope="option">
        {{ option.micro_area }}
      </template>
      <div slot="no-options">Não há opções correspondentes</div>
    </vue-select>
  </div>
</template>

<script>
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import utils from '@/mixins/utils.js'

export default {
  name: 'Selects',
  components: {
    VueSelect,
  },
  mixins: [utils],
  props: {
    activeSelectEquipes: {
      type: Boolean,
      default: true,
    },
    callbackOnChangeEquipe: {
      type: [Function, Boolean],
      default: false,
    },
    activeOptionSemEquipe: {
      type: Boolean,
      default: false,
    },
    activeSelectProfissionais: {
      type: Boolean,
      default: true,
    },
    callbackOnChangeProfissional: {
      type: [Function, Boolean],
      default: false,
    },
    activeOptionTodos: {
      type: Boolean,
      default: false,
    },
    activeSelectMicroArea: {
      type: Boolean,
      default: false,
    },
    callbackOnChangeMicroArea: {
      type: [Function, Boolean],
      default: false,
    },
  },
  data() {
    return {
      profissional: null,
      profissionais: [],
      microarea: null,
      microareas: [],
      loadingSelectProfissionais: false,
      disabledSelectProfissionais: false,
      loadingSelectMicroAreas: false,
      disabledSelectMicroAreas: false,
    }
  },
  computed: {
    equipes() {
      let data = this.$store.getters['getEquipes']
      if (this.activeOptionSemEquipe) {
        data.push({
          nu_ine: 'sem-equipe',
          no_equipe: 'SEM EQUIPE',
        })
      }
      return this.removeDuplicate(data, 'nu_ine')
    },
  },
  async mounted() {
    if (this.activeSelectEquipes == false) {
      let nu_ine_profissional =
        this.$store.state.id_funcao == 8 ||
        this.$store.state.id_funcao == 14 ||
        this.$store.state.id_funcao == 15
          ? this.$store.state.nu_ine_vinculada
          : this.$store.state.nu_ine
      await this.carregarProfissionaisAcsPorEquipe(this.$store.state.nu_ine)
      await this.carregarMicroAreasPorEquipeLocal(nu_ine_profissional)
    }
  },
  methods: {
    async handleEquipe(val) {
      try {
        this.profissional = null
        this.microarea = null
        if (val != null) {
          // carrega os profissionais ACS
          if (val.nu_ine != 'sem-equipe') {
            this.loadingSelectProfissionais = true
            this.disabledSelectProfissionais = true

            if (this.activeSelectProfissionais) {
              await this.carregarProfissionaisAcsPorEquipe(val.nu_ine)
            }
          } else {
            this.profissionais = []
          }
          // carrega as microareas
          if (this.activeSelectMicroArea) {
            await this.carregarMicroAreasPorEquipeLocal(val.nu_ine)
          }
        }
        this.callbackOnChangeEquipe(val)
      } catch (error) {
        console.log(error)
      }
    },

    handleProfissional(val) {
      this.microarea = null
      this.callbackOnChangeProfissional(val)
    },

    handleMicroArea(val) {
      this.profissional = null
      this.callbackOnChangeMicroArea(val)
    },

    async carregarProfissionaisAcsPorEquipe(nu_ine) {
      try {
        const response = await this.$api.get(
          '/app/profissionais/acs/' + this.$store.state.cod_ibge + '/' + nu_ine
        )
        if (response) {
          this.profissionais = response.data
          if (this.activeOptionTodos) {
            this.profissionais.push({
              nu_cpf: 'todos',
              no_profissional: 'TODOS',
            })
          }
          this.disabledSelectProfissionais = false
          this.loadingSelectProfissionais = false
        }
      } catch (error) {
        console.log(error)
      }
    },

    async carregarMicroAreasPorEquipe(nu_ine) {
      try {
        this.loadingSelectMicroAreas = true
        this.disabledSelectMicroAreas = true
        const response = await this.$api.get(
          '/app/equipe/' +
            this.$store.state.cod_ibge +
            '/' +
            nu_ine +
            '/microareas'
        )
        this.microareas = response.data
        this.disabledSelectMicroAreas = false
        this.loadingSelectMicroAreas = false
      } catch (error) {
        console.log(error)
      }
    },

    async carregarMicroAreasPorEquipeLocal(nu_ine) {
      this.loadingSelectMicroAreas = true
      this.disabledSelectMicroAreas = true
      let microAreas = this.$store.state.microAreas
      if (microAreas != null) {
        this.microareas = microAreas
          .filter((item) => {
            return item.ine_fci === nu_ine
          })
          .map((item) => ({ micro_area: item.micro_area }))
      } else {
        this.microareas = []
      }
      this.disabledSelectMicroAreas = false
      this.loadingSelectMicroAreas = false
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-selects {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  margin: 10px auto 30px;
  .v-select {
    flex: 0 1 33%;
    font-size: 14px;
    .vs__dropdown-toggle {
      /* background-color: #fff; */
      padding: 5px;
    }
  }
}

@media screen and (max-width: 656px) {
  .filter-selects {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
    .v-select {
      width: 100%;
      margin-bottom: 10px;
    }
  }
}

@media screen and (min-width: 657px) and (max-width: 807px) {
  .filter-selects {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
    .v-select {
      width: 100%;
      margin-bottom: 10px;
    }
  }
}

@media screen and (min-width: 808px) and (max-width: 1023px) {
  .filter-selects {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
    .v-select {
      width: 100%;
      margin-bottom: 10px;
    }
  }
}

@media screen and (min-width: 1024px) and (max-width: 1265px) {
}
</style>

<style lang="scss">
.filter-selects {
  .v-select {
    .vs__dropdown-toggle {
      height: 45px;
    }
  }
}
</style>
